import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from "dompurify";

import { HRC } from './styles';

const HtmlRaw = ({ html, style, className }) => {
  const setupRoutine = () => {
    // insert here all functions to fire
  };

  useEffect(() => {
    setupRoutine();
  }, []);

  return html ? (
    <HRC
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
      style={style}
    />
  ) : null;
};

HtmlRaw.propTypes = {
  html: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default HtmlRaw;
